<script setup>
import { ref, onMounted } from 'vue'
import { useAssessmentsStore } from '../stores'
import iconArrowRight from '~/assets/icon_arrow_right.svg'
import iconArrowLeft from '~/assets/icon_arrow_left.svg'

const assessmentsStore = useAssessmentsStore()
const comment = ref('')
const optionSelect = ref(undefined)

const emit = defineEmits(['previous', 'next'])

const props = defineProps({
    milestoneId: Number,
    milestoneAchievement: Number,
    milestoneText: String,
    note: Object,
    assessmentId: String,
    first: Boolean,
    last: Boolean,
})

const options = [
    { text: 'YES', value: 2 },
    { text: 'NO', value: 0 },
    { text: 'MAYBE', value: 1 },
]

onMounted(() => {
    if (props.milestoneAchievement) {
        optionSelect.value = props.milestoneAchievement
    }
    if (props.note) {
        comment.value = props.note.content
    }
})

const updateMilestoneAndEmit = (emitEvent) => {
    const mappedMilestones = []
    if (props.milestoneId) {
        mappedMilestones.push({
            id: props.milestoneId,
            achieved: optionSelect.value >= 2,
            achievement_level: optionSelect.value
        })
    }
    const payload = { id: props.assessmentId, assessment_milestones: mappedMilestones, notes: comment.value, completed: !props.milestoneId }
    if (props.note) {
        payload.note_id = props.note.id
    }
    assessmentsStore.patchReadinessAssessment(payload)
    emit(emitEvent)
}

</script>
<template>
    <div class="font-normal text-sm font-serif text-gray-700 text-ellipsis max-h-fit pb-1 ">
        <div class="">
            <div class="border border-1 border-black rounded-xl h-40 p-2 flex flex-col bg-white " v-if="props.milestoneId">
                <div class="font-semibold">{{ props.milestoneText }}</div>
                <div class="flex flex-col items-center content-center text-left pt-2 pl-4">
                    <div v-for="option in options" class="flex flex-row w-full items-between pt-1">
                        <input :id="`${milestoneId}-${option.value}-radio`" :name="`${milestoneId}-achieved-radio`"
                            type="radio" :value="option.value" v-model="optionSelect"
                            class="w-4 h-4 text-secondary bg-gray-200 border-gray-300 rounded focus:ring-secondary focus:ring-2 rounded-full pr-2">
                        <label :for="`${option.value}-radio`" class="ml-2 text-sm text-gray-500">{{ option.text }}</label>
                    </div>
                </div>
            </div>
        </div>
        <textarea type="text" placeholder="comments" v-model="comment"
            class="text-black text-left text-sm mt-4 border-1 border-black rounded-xl py-2 w-full" rows="5" />
        <div class="flex flex-row justify-between w-full mt-2 items-center">
            <div class=" basis-2/12 justify-self-start items-center">
                <img class="w-6 h-6  cursor-pointer" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :src="iconArrowLeft"
                    @click="updateMilestoneAndEmit('previous')" v-show="!props.first" />
            </div>
            <div v-if="last" class="basis-4/12 justify-self-end content-center ">
                <button class="w-full text-gray-50 self-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm py-3 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    type="button" @click="updateMilestoneAndEmit('next')">Finish</button>
            </div>
            <img v-else class="w-6 h-6 basis-2/12 justify-self-end cursor-pointer" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :src="iconArrowRight"
                @click="updateMilestoneAndEmit('next')" />
        </div>
    </div>
</template>